export default __webpack_public_path__ + "static/media/admin-trailer-add.0fc9fbb8.png";